<template>
  <div class="test-login">
    <van-loading v-if="loading" size="34px" vertical>正在进入测试商城…</van-loading>
    <div v-else class="result">
      <van-icon :name="success ? 'passed' : 'warning-o'" :class="success ? 'success' : 'error'" />
      <h2>{{ title }}</h2>
      <p>{{ message }}</p>
      <van-button v-if="success" type="primary" block @click="enterShop">进入测试商城</van-button>
    </div>
  </div>
</template>

<script>
import CommonService from '@/io/common.js';
import {
  isDevTestLoginEnabled,
  restoreDevTestLoginSession,
  saveDevTestLoginSession
} from '@/io/dev-test-login.js';

export default {
  name: 'TestLogin',
  data() {
    return {
      loading: true,
      success: false,
      title: '测试登录失败',
      message: '',
      redirectPath: '/home'
    };
  },
  mounted() {
    if (!isDevTestLoginEnabled()) {
      this.fail('当前环境未开启测试登录');
      return;
    }

    const requestedPath = String(this.$route.query.redirect_url || '/home');
    if (requestedPath.charAt(0) === '/' && requestedPath.indexOf('//') !== 0) {
      this.redirectPath = requestedPath;
    }

    const ticket = String(this.$route.query.ticket || '');
    // 票据只保留在内存中，兑换前即从地址栏移除，避免复制或截图泄漏。
    window.history.replaceState(null, document.title, `${window.location.pathname}#/test_login`);

    if (!ticket) {
      if (restoreDevTestLoginSession(this.$store)) {
        this.loading = false;
        this.success = true;
        this.title = '测试登录仍然有效';
        this.message = '可以继续进入测试商城。';
      } else {
        this.fail('请从测试后台重新生成一次性登录二维码');
      }
      return;
    }

    CommonService.exchangeDevTestLogin(ticket).then(res => {
      this.$store.commit('setReqParams', {
        openid: res.openid,
        token: res.token
      });
      this.$store.commit('setSelectedUserinfoId', res.userinfo_id || null);
      saveDevTestLoginSession(res);
      this.loading = false;
      this.success = true;
      this.title = '测试登录成功';
      this.message = '正在进入测试商城，请使用货到付款完成测试订单。';
      this.enterShop();
    }).catch(error => {
      const response = error && error.data ? error.data : null;
      this.fail(response && response.err_msg ? response.err_msg : '登录链接已使用或已过期，请重新生成');
    });
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.success = false;
      this.message = message;
    },
    enterShop() {
      this.$router.replace({ path: this.redirectPath });
    }
  }
};
</script>

<style lang="less" scoped>
.test-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: #f7f8fa;

  .result {
    width: 100%;
    padding: 48px 32px;
    text-align: center;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, .06);

    .van-icon {
      font-size: 64px;
    }

    .success {
      color: #07c160;
    }

    .error {
      color: #ee0a24;
    }

    h2 {
      margin: 24px 0 12px;
      font-size: 22px;
    }

    p {
      margin-bottom: 28px;
      color: #646566;
      font-size: 15px;
      line-height: 1.6;
    }
  }
}
</style>
